<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{event.name}}</span>
    </v-card-title>
    <v-card-text>
      <v-chip v-for="tag in event.tags" :key="tag.id" :color="tag.eventtags_id.color" :text-color="$getContrastColorByColor(tag.eventtags_id.color)" class="ma-1" small>{{tag.eventtags_id.name}}</v-chip>
      <v-container>
        <v-row>
          <v-col cols="12" style="white-space: pre-line">
            {{event.description}}
          </v-col>
          <!--<v-col cols="6" v-if="event.address">
            <b>Adresse</b><br />
            {{event.address}}
          </v-col>-->
          <v-col cols="6">
            <b>Kontaktdaten</b> <br />
            {{event.contact}}
          </v-col>
          <v-col v-if="event.id == 16 || event.id == 20 || event.id == 84" cols="6">
            <v-img width="200px" src="@/assets/DGS-Symbol.jpg" />
          </v-col>
        </v-row>
        <!--<v-row>
          <v-col cols="12">
            <v-btn v-if="event.link" :href="improveURL(event.link)" target="_blank" outlined>Zur externen Eventseite</v-btn>
          </v-col>
        </v-row>-->
        <v-row v-if="event.exhibitors_id && event.id != 49 && event.name.search('LIVESTREAM') == -1">
          <v-col>
            <span style="text-align:center; width: 100%" >
              Diese Veranstaltung findet am 14.02. am virtuellen Stand des Ausstellers statt. Um den Stand zu betreten, klicke bitte auf „Virtuellen Stand öffnen“ unten im Steckbrief.
            </span>
          </v-col>
        </v-row>
        <v-row v-if="event.exhibitors_id && linkToExhibitor && event.id != 49 && event.name.search('LIVESTREAM') == -1" justify="space-around">
          <v-col cols="3">
            <v-btn :to="'/aussteller/' + event.exhibitors_id.id" text outlined>Zum Steckbrief</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="event.exhibitors_id && event.id == 49">
          <span style="text-align:center; width: 100%" >
              Diese Veranstaltung findet am 14.02. im System des Ausstellers statt.<br />
              Die Anmeldung erfolgt <a :href="improveURL(event.link)">hier</a>
            </span>
        </v-row>
        <v-row v-if="event.exhibitors_id && event.name.search('LIVESTREAM') > -1">
          <span style="text-align:center; width: 100%" >
              Diese Veranstaltung findet am 14.02. im Livestream auf der <a href="/">Startseite</a> statt.
            </span>
        </v-row>
        <!--
        <v-form v-if="event.exhibitors_id" ref="form">
          <v-row>
            <v-col cols="12">
              <b>Anmeldung</b>
            </v-col>
            <v-col sm="6" md="4" lg="6">
              <v-text-field v-model="name" maxlength="60" label="Name" :rules="[rules.required]" />
            </v-col>
            <v-col sm="6" lg="6">
              <v-text-field v-model="people" label="Anzahl der Personen" />
            </v-col>
            <v-col sm="6" lg="6">
              <v-text-field v-model="mail" label="E-Mail" :rules="[rules.required, rules.email]"/>
            </v-col>
            <v-col sm="6" lg="6">
              <v-text-field v-model="phone" maxlength="40" label="Telefonnummer" />
            </v-col>
          </v-row>
        </v-form>-->
        
      </v-container>
    </v-card-text>
    <!--
    <v-card-actions v-if="event.exhibitors_id">
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="sendMessage()" outlined>Abschicken</v-btn>
    </v-card-actions>
    -->
  </v-card>
</template>

<script>
  import axios from "axios"

  export default {
    name: 'EventPopup',
    props:['event', 'linkToExhibitor'],
    data: () => ({
      dialog: false,
      name: null,
      mail:'',
      people: 1,
      phone: null,
      exhibitorId: null,
      eventname:'',
      rules:{
        required: value => {
          return !!value || 'Feld wird benötigt'
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'E-Mail ungültig'
        },
      }
    }),
    methods: {
      sendMessage: async function () {
      
        if (!this.$refs.form.validate()) return null
        
        this.eventname = this.event.name
        this.exhibitorId = this.event.exhibitors_id.id
      
        var sendMessage = axios.create( {baseURL: process.env.VUE_APP_FUNCIONS_URL});

        await sendMessage.post('/sendMessage', this.$data).then((result) => {

          this.$refs.form.reset();
          this.$emit('close')
          
        }).catch((error)=>{console.log(error)})
      },
      improveURL(url) {
      if (!/^https?:\/\//i.test(url)) {
        url = 'http://'  + url;
      }

      return url
    }
    }
  }
</script>